import axios from 'axios';
import api from './api';

const publicApi = axios.create({
  baseURL: process.env.REACT_APP_API_URL
    ? `${process.env.REACT_APP_API_URL}/api/external-reporting-referrals`
    : '/api/external-reporting-referrals',
  withCredentials: true,
  headers: { 'Content-Type': 'application/json' }
});

export const listExternalReferrals = async () =>
  (await api.get('/external-reporting-referrals')).data;

export const searchReferralStudies = async (query) =>
  (await api.get('/external-reporting-referrals/studies/search', { params: { q: query } })).data;

export const createExternalReferral = async (data) =>
  (await api.post('/external-reporting-referrals', data)).data;

export const resendExternalReferral = async (id, data = {}) =>
  (await api.post(`/external-reporting-referrals/${id}/resend`, data)).data;

export const revokeExternalReferral = async (id) =>
  (await api.post(`/external-reporting-referrals/${id}/revoke`)).data;

export const acknowledgeReferralUrgentFinding = async (id) =>
  (await api.post(`/external-reporting-referrals/${id}/urgent/acknowledge`)).data;

export const openExternalReferral = async (token, clinicianName, action = 'accept') =>
  (await publicApi.post('/public/open', { token, clinicianName, action })).data;

const sessionConfig = token => ({ headers: { Authorization: `Bearer ${token}` } });

export const getExternalReferralCase = async token =>
  (await publicApi.get('/public/case', sessionConfig(token))).data;

export const saveExternalReferralDraft = async (token, draft) =>
  (await publicApi.put('/public/draft', { draft }, sessionConfig(token))).data;

export const submitExternalReferralUrgentFinding = async (token, message) =>
  (await publicApi.post('/public/urgent-finding', { message }, sessionConfig(token))).data;

export const finalizeExternalReferralReport = async (token, draft, clinicianName) =>
  (await publicApi.post('/public/finalize', { draft, clinicianName }, sessionConfig(token))).data;

export const openReferralDocument = async (token, reportId) => {
  const response = await publicApi.get(
    `/public/documents/${encodeURIComponent(reportId)}`,
    { ...sessionConfig(token), responseType: 'blob' }
  );
  const url = URL.createObjectURL(response.data);
  window.open(url, '_blank', 'noopener,noreferrer');
  window.setTimeout(() => URL.revokeObjectURL(url), 60_000);
};
